import {makeStyles} from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    eventName: {
      fontWeight: "500",
      fontSize: "13px"
    },
    eventDesc: {
      fontSize: "11px",
      color: "#888",
      marginTop: "2px"
    },
    badge: {
      display: "inline-flex",
      alignItems: "center",
      fontSize: "11px",
      fontWeight: 500,
      padding: "3px 10px",
      borderRadius: "99px"
    },
    badgeError: {
      background: "#fef2f2",
      color: "#b91c1c"
    },
    badgeWarning: {
      background: "#fffbeb",
      color: "#92400e"
    },
    badgeInfo: {
      background: "#eff6ff",
      color: "#1d4ed8"
    },
    affected: {
      color: "#dc2626",
      fontWeight: 500
    },
    affectedWarn: {
      color: "#d97706",
      fontWeight: 500
    },
    affectedInfo: {
      color: "#2563eb",
      fontWeight: 500
    },
    exampleText: {
      fontSize: "12px",
      color: "#888",
      maxWidth: "260px"
    },
    showLink: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      color: "#2563eb",
      fontSize: "13px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      background: "none",
      border: "none",
      padding: 0,

      "&:hover": {
        textDecoration: "underline"
      }
    },
    modalPanel: {
      position: "absolute",
      top: "10px",
      right: "-10px",
      width: "400px",
      background: "#fff",
      border: "0.5px solid #e0e0e0",
      borderRadius: "12px",
      padding: "16px",
      zIndex: 50,
      boxShadow: "0 4px 24px rgba(0,0,0,0.10)"
    },
    modalHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "4px",

      "& h3": {
        fontSize: "15px",
        fontWeight: 500,
        marginBottom: 0
      }
    },
    modalClose: {
      background: "none",
      border: "none",
      cursor: "pointer",
      color: "#888",
      fontSize: "20px",
      display: "flex",
      alignItems: "center",
      padding: "2px",

      "&.hover": {
        color: "#333"
      }
    },
    modalSub: {
      fontSize: "12px",
      color: "#888",
      marginBottom: "12px",
      marginTop: 0
    },
    modalList: {
      maxHeight: "300px",
      overflowY: "auto"
    },
    modalListRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "7px 0",
      borderBottom: "0.5px solid #f0f0f0",
      fontSize: "12px",

      "&:last-child": {
        borderBottom: "none"
      },

      "& span:last-child": {
        color: "#888"
      }
    },
    copyListBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      background: "none",
      border: "0.5px solid #c8c8c8",
      borderRadius: "8px",
      padding: "6px 12px",
      fontSize: "12px",
      cursor: "pointer",
      color: "#1a1a1a",
      marginBottom: "12px"
    },
  }));
  return styles();
}
export default theme;
